import { isEmpty, isEmail } from '../../libs/validation/validators'
export default function validateAuth(values) {
  let errors = {};
  Object.keys(values).map(key => {
    console.log(values)
    switch (key) {
      case "email":
        if (isEmpty(values.email)) {
          errors.email = "Please Enter Email Adress";
        } else {
          if (!isEmail(values.email)) {
            errors.email = "Email ID format should be : name@example.com";
          }
        }
        break;
    }
  });
  console.log(errors)
  return errors;
}
